export default "__VITE_ASSET__DOvAMt8D__"